var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UNLOCK",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #UNLOCK .cls-1 {\n        fill: #c5d75d;\n        stroke: #c5d75d;\n      }\n\n      #UNLOCK .cls-2 {\n        fill: #151517;\n      }\n\n      #UNLOCK .cls-3 {\n        stroke: none;\n      }\n\n      #UNLOCK .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfd_UNLOCK",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_984",
    "data-name": "Gruppe 984",
    transform: "translate(43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    className: "cls-1",
    transform: "translate(-46 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12,
    cy: 12,
    r: 11.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_135",
    "data-name": "Pfad 135",
    className: "cls-2",
    d: "M15,8.3H8.6V6.8a1.923,1.923,0,0,1,1.9-2,1.988,1.988,0,0,1,1.9,2h1.1a3.188,3.188,0,0,0-3-3.2,3.057,3.057,0,0,0-3,3.2V8.3H6v7.4h9Zm-3.5,5.8h-2l.3-2A1.255,1.255,0,0,1,9.2,11a1.3,1.3,0,0,1,2.6,0,1.149,1.149,0,0,1-.6,1.1Z",
    transform: "translate(-44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.fc40cbd108d73bb65a5ecd3a7c3dbb6c.svg";
export { ForwardRef as ReactComponent };